/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import styles from '../../../style';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  InputAdornment
} from '@material-ui/core';
import {
  CheckOutlined,
  ClearOutlined,
  Edit,
  DeleteOutline,
  CalendarToday
} from '@material-ui/icons';
import { connect } from 'react-redux';
import {
  saveVaccinations,
  updateVaccinations,
  deleteVaccinations,
  getPatientMedicalHistory
} from 'services/soap/action';

const Vaccinations = props => {
  const { classes,  patientId, getPatientMedicalHistory, ptMedicalHistory } = props;

  const initialUserState = {
    id: 0,
    name: '',
    dategiven: new Date(),
    lot: ''
  };
  const [values, setValues] = useState(initialUserState);
  const [editvalues, setEditValues] = useState(initialUserState);
  const [vaccination, setVaccination] = useState(props.vaccinations);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (ptMedicalHistory?.vaccinations && ptMedicalHistory?.vaccinations?.length > 0) {
      setVaccination(ptMedicalHistory.vaccinations);
    }
  }, [ptMedicalHistory]);

  const handleFieldChange = (field, value) => {
    setValues({ ...values, [field]: value });
  };

  const handleEditFieldChange = (field, value) => {
    setEditValues({ ...editvalues, [field]: value });
  };

  const handleSaveVaccinations = async () => {
    if (values.name || values.lot) {
      const res = await props.saveVaccinations(patientId, values);
      if (res.status) {
        getPatientMedicalHistory(patientId);
        setValues(initialUserState); 
      }
    }
  };

  const handleUpdateVaccinations = async idx => {
    if (editvalues.name || editvalues.lot) {
      const res = await props.updateVaccinations(patientId, editvalues);
      if (res.status) {
       getPatientMedicalHistory(patientId);
        setIsEdit(false); 
      }
    }
  };

  const handleDeleteVaccinations = async id => {
    const res = await props.deleteVaccinations(patientId, id);
    if (res.status) { 
      setValues(initialUserState);
      getPatientMedicalHistory(patientId);
    }
  };

  const handleEditVaccinations = async (data, index) => {
    setIsEdit(true);
    if (data) {
      setEditValues({
        id: data.id,
        name: data.name,
        dategiven: data.dategiven,
        lot: data.lot,
        editIndex: index
      });
    }
  };

  const clearVaccinations = () => {
    setIsEdit(false);
    setValues(initialUserState);
  };

  return (
    <div className={classes.templateWrap}>
      <div className={classes.templateBody} style={{ borderTop: 'default' }}>
        {/* <PerfectScrollbar> */}
        <div style={{ maxHeight: 'calc(100vh - 298px)' }}>
          <Table className={classes.templateTable}>
            <TableHead>
              <TableRow>
                <TableCell width="20%">
                  <TextField
                    className={classes.textBox}
                    id="outlined-basic"
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline
                      }
                    }}
                    onChange={event =>
                      handleFieldChange('name', event.target.value)
                    }
                    placeholder="Input Name"
                    value={values.name}
                    variant="outlined"
                  />
                </TableCell>

                <TableCell width="30%">

                  <DatePicker
                    customInput={
                      <TextField
                        className={classes.textField}
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment>
                              <CalendarToday
                                style={{ height: 16, width: 16 }}
                              />
                            </InputAdornment>
                          )
                        }}
                        // label="Date Recorded"
                        margin="dense"
                        variant="outlined"
                      />
                    }
                    format="MM/DD/YYYY"
                    onBlur={e => (e.target.placeholder = 'dategiven')}
                    onChange={date =>
                      handleFieldChange(
                        'dategiven',
                        date
                      )
                    }
                    onFocus={e => (e.target.placeholder = 'Date Recorded')}
                    placeholderText="dategiven"
                    selected={
                      values.dategiven &&
                      new Date(values.dategiven)
                    }
                    showMonthDropdown="bool"
                    showYearDropdown="bool"
                  />
                </TableCell>

                <TableCell width="60%">
                  <TextField
                    className={classes.textBox}
                    id="outlined-basic"
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline
                      }
                    }}
                    onChange={event =>
                      handleFieldChange('lot', event.target.value)
                    }
                    placeholder="Comments"
                    value={values.lot}
                    variant="outlined"
                  />
                </TableCell>
                <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>
                  <IconButton
                    // disabled={values.name || values.lot}
                    onClick={() => handleSaveVaccinations()}
                    size="small"
                    style={{ color: '#03A484' }}>
                    <CheckOutlined />
                  </IconButton>
                  <IconButton
                    onClick={() => clearVaccinations()}
                    size="small">
                    <ClearOutlined style={{ color: '#DE5555' }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vaccination &&
                vaccination.length > 0 &&
                vaccination.map((item, idx) => {
                  return (
                    <TableRow>
                      {isEdit && idx === editvalues.editIndex ? (
                        <>
                          <TableCell width="20%">
                            <TextField
                              className={classes.textBox}
                              id="outlined-basic"
                              InputProps={{
                                classes: {
                                  notchedOutline: classes.notchedOutline
                                }
                              }}
                              onChange={event =>
                                handleEditFieldChange(
                                  'name',
                                  event.target.value
                                )
                              }
                              placeholder="Input Name"
                              value={editvalues.name}
                              variant="outlined"
                            />
                          </TableCell>

                          <TableCell width="30%">

                            <DatePicker
                              customInput={
                                <TextField
                                  className={classes.textField}
                                  fullWidth
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment>
                                        <CalendarToday
                                          style={{ height: 16, width: 16 }}
                                        />
                                      </InputAdornment>
                                    )
                                  }}
                                  // label="Date Recorded"
                                  margin="dense"
                                  variant="outlined"
                                />
                              }
                              format="MM/DD/YYYY"
                              onBlur={e => (e.target.placeholder = 'dategiven')}
                              onChange={date =>
                                handleEditFieldChange(
                                  'dategiven',
                                  date
                                )
                              }
                              onFocus={e => (e.target.placeholder = 'Date Recorded')}
                              placeholderText="dategiven"
                              selected={
                                editvalues.dategiven &&
                                new Date(editvalues.dategiven)
                              }
                              showMonthDropdown="bool"
                              showYearDropdown="bool"
                            />
                          </TableCell>

                          <TableCell width="60%">
                            <TextField
                              className={classes.textBox}
                              id="outlined-basic"
                              InputProps={{
                                classes: {
                                  notchedOutline: classes.notchedOutline
                                }
                              }}
                              onChange={event =>
                                handleEditFieldChange(
                                  'lot',
                                  event.target.value
                                )
                              }
                              placeholder="Comments"
                              value={editvalues.lot}
                              variant="outlined"
                            />
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell>{item && item.name}</TableCell>
                          <TableCell>
                            {item && item.dategiven
                              ? moment(item.dategiven).format('MM/DD/YYYY')
                              : ''}
                          </TableCell>
                          <TableCell>{item && item.lot}</TableCell>
                        </>
                      )}
                      <TableCell align="center" width={72}>
                        {isEdit && idx === editvalues.editIndex ? (
                          <>
                            <IconButton
                              // disabled={values.name || values.reaction}
                              onClick={() => handleUpdateVaccinations(idx)}
                              size="small"
                              style={{ color: '#03A484' }}>
                              <CheckOutlined />
                            </IconButton>
                            <IconButton
                              onClick={() => clearVaccinations()}
                              size="small">
                              <ClearOutlined style={{ color: '#DE5555' }} />
                            </IconButton>
                          </>
                        ) : (
                          <>
                            <IconButton
                              onClick={() =>
                                handleEditVaccinations(item, idx)
                              }
                              size="small">
                              <Edit color="primary" />
                            </IconButton>
                            <IconButton
                              onClick={() =>
                                handleDeleteVaccinations(item.id)
                              }
                              size="small">
                              <DeleteOutline style={{ color: '#DE5555' }} />
                            </IconButton>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
        {/* </PerfectScrollbar> */}
      </div>
    </div>
  );
};
Vaccinations.propTypes = {
  className: PropTypes.string
};
const mapDispatchToProps = {
  saveVaccinations,
  updateVaccinations,
  deleteVaccinations,
  getPatientMedicalHistory
};

const mapStateToProps = (state) => ({
  ptMedicalHistory: state.soap && state.soap.ptMedicalHistory,
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Vaccinations))
);
